import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';
import { BLOCKS } from '@contentful/rich-text-types';

import Container from '../../../Core/Container';
import RichText from '../../../Core/RichText';
import Link from '../../../Core/Link';
import { isNotEmpty } from '../../../../utils';

import { Title, CDIC, Img } from './styles';

const richTextContentAsTitle = (_, children) =>
  isNotEmpty(children) ? <Title>{children}</Title> : null;

const title = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: richTextContentAsTitle,
    [BLOCKS.HEADING_1]: richTextContentAsTitle,
  },
};

const CDICScreen = ({ data }) => {
  if (!data) return null;
  const { heading } = data;
  const intl = useIntl();
  return (
    <Container>
      {heading && <RichText document={heading} options={title} />}
      <CDIC>
        {intl.locale === 'en' ? (
          <div className="ok-checker-wrapper" id="cdic-ok-checker-badge">
            <Link
              id="ok-checker-link"
              className="unstyled-link"
              to="https://www.cdic.ca/your-coverage/protecting-your-deposit/?widget=1"
            >
              <Img
                id="ok-checker-sign-image"
                alt="CDIC Digital Membership Sign - This logo signifies that this institution is a CDIC Member"
                src="https://www.cdic.ca/app2/uploads/images/confirmed_en.svg"
              />
            </Link>
          </div>
        ) : (
          <div
            className="ok-checker-wrapper"
            style={{
              width: '400px',
              border: '0',
              display: 'inline-block',
              position: 'relative',
              transform: 'unset',
            }}
            id="cdic-ok-checker-badge"
          >
            <a
              id="ok-checker-link"
              href="https://www.sadc.ca/a-propos-de-lassurance-depots/quels-depots-sont-proteges/?widget=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                id="ok-checker-sign-image"
                alt="Avis numérique d'adhésion à la SADC -- ce logo signifie que l'institution est membre de la SADC"
                src="https://www.sadc.ca/app2/uploads/images/confirmed_fr.svg"
              />
            </a>
          </div>
        )}
      </CDIC>
    </Container>
  );
};

CDICScreen.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CDICScreen;
